/* eslint-disable no-console */
import {Flex, Select} from 'antd';
import React, {useMemo, useState} from 'react';

import {sortBy} from '../../../../../shared/commonFunctions';
import Year from '../../../../../shared/Year';
import {stakeholdersTypeKeyLabel, stakeHolderIntExt} from '../constants/common';

const StakeholderFilterComp: React.FC<{
  setSelectedYear: React.Dispatch<React.SetStateAction<string>>;
  setStakeholderType: React.Dispatch<React.SetStateAction<string>>;
  stakeholderType: string;
  setProgressFilter: React.Dispatch<React.SetStateAction<any>>;
  isDisabled?: boolean;
}> = ({
  setSelectedYear,
  setStakeholderType,
  stakeholderType,
  setProgressFilter,
  isDisabled = false
}) => {
  const [stakeHolderSelected, setStakeHolderSelected] = useState<string>(
    stakeHolderIntExt?.[0]?.value
  );

  const stakeholdersTypeOptions = useMemo(() => {
    const options = stakeholdersTypeKeyLabel.filter((item) => {
      return item?.stakeholder === stakeHolderSelected;
    });

    return options;
  }, [stakeHolderSelected]);

  return (
    <Flex justify="end" gap={10} className="dropdownFilterZIndex">
      <Year
        setSelectedYear={setSelectedYear}
        isESG
        noPadding
        noBottomMargin
        colSpan={24}
        isDisabled={isDisabled}
      />
      <Select
        defaultValue={stakeHolderSelected}
        value={stakeHolderSelected}
        options={sortBy(stakeHolderIntExt, 'label', 'asc')}
        placeholder="Stakeholder"
        disabled={isDisabled}
        onChange={(e) => {
          setStakeHolderSelected(e);
          setStakeholderType(
            stakeholdersTypeKeyLabel?.filter((item) => {
              return item?.stakeholder === e;
            })?.[0]?.value
          );
          setProgressFilter(undefined);
        }}
        style={{width: '200px'}}
        dropdownStyle={{zIndex: 100}}
      />
      <Select
        defaultValue={stakeholderType}
        value={stakeholderType}
        options={sortBy(stakeholdersTypeOptions, 'label', 'asc')}
        onChange={(e) => {
          setStakeholderType(e);
          setProgressFilter(undefined);
        }}
        disabled={isDisabled}
        placeholder="Category"
        style={{width: '200px'}}
        dropdownStyle={{zIndex: 100}}
      />
    </Flex>
  );
};

export default StakeholderFilterComp;
